import { useState } from 'react'
import { PageContainer, PageHeader } from '../../components/Layout'
import { Button, Card, CardContent, Input, Select, Badge } from '../../components/UI'
import { rentalTechService } from '../../services/api'

const countryOptions = [
  { value: 'colombia', label: 'Colombia - DIAN' },
  { value: 'mexico', label: 'Mexico - SAT' },
  { value: 'peru', label: 'Peru - SUNAT' }
]

export default function RentalTechBilling() {
  const [form, setForm] = useState({ country: 'colombia', vatRatePct: 19 })
  const [invoices, setInvoices] = useState([])
  const [loading, setLoading] = useState(false)

  const closePeriod = async () => {
    setLoading(true)
    try {
      const response = await rentalTechService.closeBilling({
        country: form.country,
        vatRatePct: Number(form.vatRatePct)
      })
      setInvoices(response?.data?.data || [])
    } finally {
      setLoading(false)
    }
  }

  return (
    <PageContainer>
      <div className="space-y-6">
        <PageHeader
          title="Facturacion Electronica LATAM"
          subtitle="Arquitectura compatible con DIAN, SAT y SUNAT"
        />

        <Card>
          <CardContent className="p-5 space-y-3">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
              <Select options={countryOptions} value={form.country} onChange={(e) => setForm({ ...form, country: e.target.value })} />
              <Input type="number" value={form.vatRatePct} onChange={(e) => setForm({ ...form, vatRatePct: e.target.value })} placeholder="IVA %" />
              <Button onClick={closePeriod} disabled={loading}>{loading ? 'Procesando...' : 'Cerrar Periodo y Generar Facturas'}</Button>
            </div>
            <p className="text-xs text-gray-500">Este flujo deja listo el modelo para integrar APIs externas de timbrado/facturacion por pais.</p>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-0 overflow-x-auto">
            <table className="w-full text-sm min-w-[860px]">
              <thead className="bg-gray-50 border-b">
                <tr className="text-left">
                  <th className="px-4 py-3">Autoridad</th>
                  <th className="px-4 py-3">Numero</th>
                  <th className="px-4 py-3">Subtotal</th>
                  <th className="px-4 py-3">IVA</th>
                  <th className="px-4 py-3">Total</th>
                  <th className="px-4 py-3">Estado</th>
                </tr>
              </thead>
              <tbody>
                {invoices.map((inv) => (
                  <tr key={inv.id} className="border-b">
                    <td className="px-4 py-3">{inv.authority_code}</td>
                    <td className="px-4 py-3">{inv.number}</td>
                    <td className="px-4 py-3">${Number(inv.subtotal || 0).toLocaleString()}</td>
                    <td className="px-4 py-3">${Number(inv.vat_amount || 0).toLocaleString()}</td>
                    <td className="px-4 py-3">${Number(inv.total || 0).toLocaleString()}</td>
                    <td className="px-4 py-3"><Badge variant="success">{inv.status}</Badge></td>
                  </tr>
                ))}
                {!invoices.length ? (
                  <tr>
                    <td className="px-4 py-10 text-center text-gray-500" colSpan={6}>Aun no hay facturas generadas para el periodo.</td>
                  </tr>
                ) : null}
              </tbody>
            </table>
          </CardContent>
        </Card>
      </div>
    </PageContainer>
  )
}
